import { LitElement, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { ApiController } from '../controllers/api-controller';
import api from '../redux/services/api';

@customElement('login-error-message')
export class LoginErrorMessage extends LitElement {
  apiController = new ApiController(this);

  @property() overrideMessage: string = '';

  createRenderRoot() {
    return this;
  }

  get endpointStatus() {
    return this.apiController.getNewestRequestStatus(api.endpoints.googleLogin.name);
  }
  
  get errorMessage(): string {
    if (!this.endpointStatus?.error) return '';
    if (this.overrideMessage) return this.overrideMessage;
    return this.endpointStatus.error.message ?? '';
  }

  _renderFormMessage(message: string, extraClass: string = '') {
    return html`
      <div class="form-message${extraClass}">
        ${message}
      </div>
    `;
  }

  render() {
    if (this.errorMessage) {
      return this._renderFormMessage(this.errorMessage, ' form-message--error');
    }

    return nothing;
  }
}
